import { RouteObject } from 'react-router-dom';
import { PpvHandlerLoader } from "../loaders/AdminFolderLoaders/PpvHandlerLoader";
import PpvHandle from "../pages/Admin/PpvHandle";
import { TypeMatchHandlerLoader } from "../loaders/AdminFolderLoaders/TypeMatchHandlerLoader";
import TypeMatchHandle from "../pages/Admin/TypeMatchHandle";
import { ArenaHandlerLoader } from "../loaders/AdminFolderLoaders/ArenaHandlerLoader";
import ArenaHandle from "../pages/Admin/ArenaHandle";
import { BeltHandlerLoader } from "../loaders/AdminFolderLoaders/BeltHandlerLoader";
import BeltHandle from "../pages/Admin/BeltHandle";
import { HallOfFameHandlerLoader } from "../loaders/AdminFolderLoaders/HallOfFameHandlerLoader";
import HallOfFameHandle from "../pages/Admin/HallOfFameHandle";
import HandleWrestler from "../pages/Admin/HandleWrestler";
import { AdminRouteProtection } from "../loaders/AdminFolderLoaders/AdminRouteProtection";
import { catalogRoutes } from "./catalogRoutes";
import UserListPage from "../pages/Admin/Users/UserListPage";

export const adminRoutes: RouteObject = {
  path: 'admin',
  children: [
    catalogRoutes,
    {
      path: 'ppv/handle',
      element: <PpvHandle />,
      loader: PpvHandlerLoader
    },
    {
      path: 'type-match/handle',
      element: <TypeMatchHandle />,
      loader: TypeMatchHandlerLoader
    },
    {
      path: 'arena/handle',
      element: <ArenaHandle />,
      loader: ArenaHandlerLoader
    },
    {
      path: 'belt/handle',
      element: <BeltHandle />,
      loader: BeltHandlerLoader
    },
    {
      path: 'hall-of-fame/handle',
      element: <HallOfFameHandle />,
      loader: HallOfFameHandlerLoader
    },
    {
      path: 'wrestler/handle',
      element: <HandleWrestler />,
      loader: AdminRouteProtection
    },
    {
      path: 'users',
      element: <UserListPage />,
      loader: AdminRouteProtection
    },
  ]
};
